import {
  AssetStakingOverviewQuery,
  AssetStakingOverviewQuery$data,
  AssetStakingOverviewQueryNode,
} from '@bts-web/data-layer/server';
import {
  getStartOfMonthYmd,
  getEndOfMonthYmd,
} from '@bts-web/utils-formatting';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export interface AssetsStakingOverviewResponse {
  data: AssetStakingOverviewQuery$data;
  errors?: string[];
}

/**
 * Loads staking overview for an asset. `startDate` / `endDate` are trusted `DateScalar` values from
 * `getStartOfMonthYmd` and `getEndOfMonthYmd` (local calendar month range), not unparsed user input.
 */
export const getAssetStakingOverviewData = async (
  assetId: string,
): Promise<AssetsStakingOverviewResponse> => {
  const startOfMonth = getStartOfMonthYmd();

  const endOfMonth = getEndOfMonthYmd();

  const response = await gqlNetworkFetch<AssetStakingOverviewQuery>(
    AssetStakingOverviewQueryNode.params,
    {
      assetId,
      startDate: startOfMonth,
      endDate: endOfMonth,
    },
  );

  return response;
};
